<template>
    <div id="wrapper_main">
        <template>
            <v-toolbar>
                <v-toolbar-side-icon></v-toolbar-side-icon>
                <v-toolbar-title>Bar</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items class="hidden-sm-and-down">
                    <v-btn text to="/auth" v-if="!logged_in">
                        <v-icon>mdi-account</v-icon>
                        <span>Login</span>
                    </v-btn>

                    <v-btn text to="/auth/logout" v-if="logged_in">
                        <v-icon>mdi-account</v-icon>
                        <span>Logout</span>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
        </template>


        <v-card class="wrapper_main_content">
            <div>
                <router-view name="router_wrapper_main" >
                </router-view>
            </div>
        </v-card>
    </div>


</template>

<script>


    export default {
        components: {
        },

        data: () => ({
            logged_in: false,
            categories: [],
            cart_items: [],

            // cart_items: [],

            search_parameters:{
                search_text: '',
                search_category: undefined,
                search_filters: []
            },

            selected_language: 'English',

            languages: ['English'],
            notifications: [
                'Mike, John responded to your email',
                'You have 5 new tasks',
                'You\'re now a friend with Andrew',
                'Another Notification',
                'Another One'
            ],
            title: null,
        }),

        created () {
            if (localStorage.getItem('access_token'))
                this.logged_in = localStorage.getItem('access_token');
             else
                this.logged_in = false;
        },
        mounted () {

        },
        beforeDestroy () {

        },


        methods: {
            selectLanguage (){

            },
        }
    }
</script>
